export default __webpack_public_path__ + "static/media/background-city.56305289.svg";